import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

import Header from "./header"
import Footer from "./footer"
import "../styles/layout.scss"

const Layout = ({ hero, children, pageslug }) => {
  const [ham, setHam] = useState(true)
  const [scrolled, setScrolled] = useState(false)
  const [firstLoad, setFirstLoad] = useState(true)
  const toggleHam = () => {
    ham ? setHam(false) : setHam(true)
    setFirstLoad(false)
  }
  const closeHam = () => {
    setHam(true)
  }
  const onScroll = () => {
    let scrolled = document.scrollingElement.scrollTop
    if (scrolled >= 10) {
      setScrolled(true)
    } else {
      setScrolled(false)
    }
  }
  useEffect(() => {
    document.addEventListener("scroll", onScroll)
    return () => {document.removeEventListener("scroll", onScroll)}
  }, [])
  return (
    <>
      <Header
        ham={ham}
        firstLoad={firstLoad}
        toggleHam={toggleHam}
        scrolled={scrolled}
        closeHam={closeHam}
        hero={hero}
      />
      <main className={pageslug}>{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
